module.exports = __webpack_public_path__ + "static/media/icons_play.1f310008.svg";